import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentReportService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    search(payload: any): Observable<any> {
        return this.post<any>(<EndPoints>'ActiveStudentLists/Search', false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,

            rAttending: payload.rAttending,
            rNotAttending: payload.rNotAttending,
            summer: payload.summer,
            intersession: payload.intersession,

            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,
            k12Ungraded: payload.k12Ungraded,
            notWithdrawnFromSchool: payload.notWithdrawnFromSchool,
            verifiedCoes: payload.verifiedCoes,

            criterion: payload.criterion,
            criterionStartDate: payload.criterionStartDate,
            criterionEndDate: payload.criterionEndDate,

            recruitedSince: payload.recruitedSince,
            recruitedSinceStartDate: payload.recruitedSinceStartDate,
            recruitedSinceEndDate: payload.recruitedSinceEndDate
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    extendedSearch(payload: any): Observable<any> {
        return this.post<any>(<EndPoints>'ActiveStudentLists/ExtendedSearch', false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,

            rAttending: payload.rAttending,
            rNotAttending: payload.rNotAttending,
            summer: payload.summer,
            intersession: payload.intersession,

            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,
            k12Ungraded: payload.k12Ungraded,
            notWithdrawnFromSchool: payload.notWithdrawnFromSchool,
            verifiedCoes: payload.verifiedCoes,

            criterion: payload.criterion,
            criterionStartDate: payload.criterionStartDate,
            criterionEndDate: payload.criterionEndDate,

            recruitedSince: payload.recruitedSince,
            recruitedSinceStartDate: payload.recruitedSinceStartDate,
            recruitedSinceEndDate: payload.recruitedSinceEndDate
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    searchStudentsBySchool(payload: any): Observable<any> {
        return this.post<any>(<EndPoints>'ActiveStudentLists/SearchStudentsBySchool', false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,

            rAttending: payload.rAttending,
            rNotAttending: payload.rNotAttending,
            summer: payload.summer,
            intersession: payload.intersession,

            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,
            notWithdrawnFromSchool: payload.notWithdrawnFromSchool,
            missingEndDate: payload.missingEndDate,

            chosenGrade: payload.chosenGrade,

            selectedService: payload.selectedService,
            servicePeriod: payload.servicePeriod,
            showServicesColumn: payload.showServicesColumn
        }).pipe(
            switchMap((result) => {
                console.log("search returned but within enrollment-report")
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
